import { Layout as AntLayout } from 'antd';
import React from 'react';
import { CoverageDetailSection } from '@components/Sections/CoverageDetailSection/CoverageDetailSection';

export const CoverageLayout = () => {
  return (
    <AntLayout
      id="coverageDetail"
      className="min-h-screen bg-[aliceblue] overflow-x-hidden"
    >
      <AntLayout.Content className="mt-[200px] mb-[30px] px-4 md:px-8 lg:px-16 ">
        <div className="flex justify-center ">
          <CoverageDetailSection />
        </div>
      </AntLayout.Content>
    </AntLayout>
  );
};
